import styled from "styled-components";

import { SWReactIcons } from "@similarweb/icons";
import { colorsPalettes, mixins } from "@similarweb/styles";
import { FlexColumn, FlexRow } from "@similarweb/ui-components";
import { Flex } from "@similarweb/ui-components/foundations";

import { truncateLongLine } from "app/pages/sales-intelligence/common-components/styles";

export const StyledQuickActionCard = styled(FlexRow)`
    border-radius: 6px;
    border: 1px solid ${colorsPalettes.blue[200]};
    background: ${colorsPalettes.carbon[0]};
    width: 265px;
    padding: 12px;
    gap: 12px;

    &:hover {
        border-radius: 6px;
        border: 1px solid ${colorsPalettes.blue[400]};
        cursor: pointer;
        box-shadow: 0 3px 6px 0 rgba(14, 30, 62, 0.08);
    }
`;

export const StyledQuickActionCardContent = styled(FlexRow)`
    align-items: flex-start;
    gap: 12px;
`;

export const StyledIconContainer = styled(Flex)`
    align-items: center;
    justify-content: center;
    border-radius: 3px;
    border: 1px solid ${colorsPalettes.blue[200]};
    background: ${colorsPalettes.carbon[0]};
    width: 24px;
    height: 24px;
`;

export const StyledSWReactIcons = styled(SWReactIcons)`
    display: flex;
    justify-content: center;
    align-items: center;
`;

export const StyledCardMainContainer = styled(FlexColumn)`
    gap: 4px;
`;

export const StyledCardTitle = styled(Flex)`
    align-items: center;
    gap: 6px;
    width: 193px;
`;

export const StyledCardTitleText = styled.span`
    ${mixins.setFontVariant("button", colorsPalettes.carbon[500])};
    ${truncateLongLine}
`;

export const StyledCardDescription = styled(Flex)`
    ${mixins.setFontVariant("listItem3", colorsPalettes.carbon[300])};
    width: 193px;
    ${truncateLongLine}
`;

export const StyledArrowContainer = styled(Flex)`
    height: 100%;
    align-items: center;
`;
